import Axios from "axios";
import { SETTINGS } from "../../../../../properties/ApiProps";

export const AuthorshipRoleRepository = {
  fetch: (id) => {
    return Axios.get(`${SETTINGS.API_URL}authorshipRoles/${id}`);
  },
  fetchAll: (gradingSchemaId) => {
    return Axios({
      url: SETTINGS.API_URL + "authorshipRoles",
      method: "GET",
      params: { gradingSchemaId: gradingSchemaId },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  create: (data) => {
    return Axios({
      url: SETTINGS.API_URL + "authorshipRoles",
      method: "POST",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  update: (data) => {
    return Axios({
      url: SETTINGS.API_URL + "authorshipRoles",
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  delete: (id) => {
    return Axios.delete(`${SETTINGS.API_URL}authorshipRoles/${id}`);
  },
};
